import { Box, Button, ButtonGroup, CircularProgress, Grid, InputAdornment, TextField, Tooltip } from "@mui/material";
import YoutubeSearchedForIcon from '@mui/icons-material/YoutubeSearchedFor';
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined';
import { IFiltrosState } from "..";
import SelectTipoCafe from "../../../../../components/SelectsSimpleApiQuery/SelectTipoCafe";
import SelectBebidaCafe from "../../../../../components/SelectsSimpleApiQuery/SelectBebidaCafe";
import SelectCorCafe from "../../../../../components/SelectsSimpleApiQuery/SelectCorCafe";
import SelectAspectoCafe from "../../../../../components/SelectsSimpleApiQuery/SelectAspectoCafe";
import DateComIntervalo from "../../../../../components/DateComIntervalo";
import SelectSafraCafe from "../../../../../components/SelectsSimpleApiQuery/SelectSafraCafe";
import PublicosAutoComplete from "../../../../../components/AutoCompletePredefinido/PublicosAutoComplete";

export default function FiltrosCabecalho({
    filtros,
    onChangeFiltro,
    onSearchData,
    onClearFiltros,
    loadingQuery = false
}: FiltrosCabecalhoProps) {


    return (
        <>
            <Grid container spacing={2}>
                <Grid size={{xs: 5}}>
                    <PublicosAutoComplete
                        valor={filtros.pesquisar_label}
                        dado={filtros.pesquisar_dado}
                        onChangeDados={(dado) => onChangeFiltro("pesquisar_dado", dado)}
                        onChangeLabel={(label) => onChangeFiltro("pesquisar_label", label)}
                    />
                </Grid>

                <Grid size={{xs: 4}}>
                    <DateComIntervalo
                        data={{
                            inicial: filtros.data_documento_inicio,
                            final: filtros.data_documento_fim
                        }}
                        onChangeData={(data) => {
                            onChangeFiltro("data_documento_inicio", data.inicial)
                            onChangeFiltro("data_documento_fim", data.final)
                        }}
                        datePickerView={['year', 'month', 'day']}
                        formatString="DD/MM/YYYY"
                        labelInput="Data documento"
                    />
                </Grid>

                <Grid size={{xs: 3}}>
                    <SelectSafraCafe
                        type="multiple"
                        value={filtros.safra}
                        onChange={(value) => onChangeFiltro("safra", value)}
                    />
                </Grid>


                <Grid size={{xs: 6, md: 2.5}}>
                    <SelectTipoCafe
                        type="multiple"
                        value={filtros.grao_tipo}
                        onChange={(value) => onChangeFiltro("grao_tipo", value)}
                    />
                </Grid>

                <Grid size={{xs: 6, md: 2.5}}>
                    <SelectBebidaCafe
                        type="multiple"
                        value={filtros.grao_bebida}
                        onChange={(value) => onChangeFiltro("grao_bebida", value)}
                    />
                </Grid>

                <Grid size={{xs: 6, md: 2.5}}>
                    <SelectCorCafe
                        type="multiple"
                        value={filtros.grao_cor}
                        onChange={(value) => onChangeFiltro("grao_cor", value)}
                    />
                </Grid>

                <Grid size={{xs: 6, md: 2.5}}>
                    <SelectAspectoCafe
                        type="multiple"
                        value={filtros.grao_aspecto}
                        onChange={(value) => onChangeFiltro("grao_aspecto", value)}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 2}}>
                    <Box display="flex" justifyContent="flex-end" height="100%">
                        <ButtonGroup
                            variant="outlined"
                            disableElevation
                            aria-label="Disabled button group"
                            sx={{
                                height: "100%"
                            }}
                        >
                            <Tooltip title="Buscar dados">
                                <Button onClick={onSearchData} disabled={loadingQuery}>
                                    {
                                        loadingQuery &&
                                        <CircularProgress size={24} sx={{ color: "#ccc" }} />
                                    }
                                    {
                                        !loadingQuery &&
                                        <YoutubeSearchedForIcon />
                                    }
                                </Button>
                            </Tooltip>

                            <Tooltip title="Limpar filtros">
                                <Button onClick={() => onClearFiltros(true)}>
                                    <BackspaceOutlinedIcon />
                                </Button>
                            </Tooltip>
                        </ButtonGroup>
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

interface FiltrosCabecalhoProps {
    filtros: IFiltrosState
    onChangeFiltro: (prop: keyof IFiltrosState, value: any) => void,
    onSearchData: () => void,
    onClearFiltros: (clearAll: boolean) => void,
    loadingQuery?: boolean
}
